import { Rating } from "@chef/components";

interface RecipeRatingProps {
  recipeId: number;
  rating: number;
  onRatingClicked: (rating: number) => void;
  size?: number;
}

export const RecipeRating = ({
  recipeId,
  rating,
  onRatingClicked,
  size = 28,
}: RecipeRatingProps) => {
  return (
    <Rating
      id={`rating-${recipeId}`}
      value={rating}
      numOptions={5}
      defaultValue={0}
      size={size}
      onChange={onRatingClicked}
    />
  );
};
